// // import Layout from './layout';

// // import Layout1 from './layout1';

// // // import '../styles/globals.css';

// // import '../styles/globaltest.css';

// // import SignIn from '.';

// // export default function MyApp({ Component, pageProps }) {
// //   if (Component === SignIn) {
// //     return (
// //       <Layout1>
// //         <Component {...pageProps} />
// //       </Layout1>
// //     );
// //   }

// //   return (
// //     <Layout>
// //       <Component {...pageProps} />
// //     </Layout>
// //   );
// // }

// import Layout from "./layout";
// import Layout1 from "./layout1";
// // import '../styles/globals.css';
// import "../styles/globaltest.css";
// import SignIn from ".";
// import ProtectedRoute from "../components/protectedroute"; // matches your filename

// export default function MyApp({ Component, pageProps }) {
//   if (Component === SignIn) {
//     // Login / index page → uses Layout1, public route
//     return (
//       <ProtectedRoute>
//         <Layout1>
//           <Component {...pageProps} />
//         </Layout1>
//       </ProtectedRoute>
//     );
//   }

//   // All other pages → uses Layout, protected route
//   return (
//     <ProtectedRoute>
//       <Layout>
//         <Component {...pageProps} />
//       </Layout>
//     </ProtectedRoute>
//   );
// }

// import Layout from "./layout";
// import Layout1 from "./layout1";
// // import '../styles/globals.css';
// import "../styles/globaltest.css";
// import SignIn from ".";
// import ProtectedRoute from "../components/protectedroute"; // matches your filename

// export default function MyApp({ Component, pageProps }) {
//   if (Component === SignIn) {
//     // Login / index page → uses Layout1, public route
//     return (
//       <ProtectedRoute>
//         <Layout1>
//           <Component {...pageProps} />
//         </Layout1>
//       </ProtectedRoute>
//     );
//   }

//   // All other pages → uses Layout, protected route
//   return (
//     <ProtectedRoute>
//       <Layout>
//         <Component {...pageProps} />
//       </Layout>
//     </ProtectedRoute>
//   );
// }


import Layout from "./layout";
import Layout1 from "./layout1";
// import '../styles/globals.css';
import "../styles/globaltest.css";
import SignIn from ".";
import ProtectedRoute from "../components/protectedroute"; // matches your filename

export default function MyApp({ Component, pageProps }) {
  if (Component === SignIn) {
    // Login / index page → uses Layout1, public route
    return (
      <ProtectedRoute>
        <Layout1>
          <Component {...pageProps} />
        </Layout1>
      </ProtectedRoute>
    );
  }

  // All other pages → uses Layout, protected route
  return (
    <ProtectedRoute>
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </ProtectedRoute>
  );
}
